// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconComputerAndMonitor } from '@ni/nimble-components/dist/esm/icons/computer-and-monitor';
import { wrap } from '../utilities/react-wrapper';

export { type IconComputerAndMonitor };
export const NimbleIconComputerAndMonitor = wrap(IconComputerAndMonitor);